module.exports = __webpack_public_path__ + "static/media/horizontal.c776134b.png";